<template>
  <div class="zyjd">
    <div class="item-zyjs" v-if="majorDetail.zyjs">
      <div class="item-title">
        <label>专业介绍</label>
      </div>
      <div class="item-text">{{majorDetail.zyjs}}</div>
    </div>
    <div class="item-zyjs" v-if="majorDetail.kskc">
      <div class="item-title">
        <label>课程介绍</label>
      </div>
      <div class="item-text">{{majorDetail.kskc}}</div>
    </div>
    <div class="item-zyjs" v-if="majorDetail.jyqj">
      <div class="item-title">
        <label>就业前景</label>
      </div>
      <div class="item-text">{{majorDetail.jyqj}}</div>
    </div>
    <div class="item-zyjs" v-if="majorDetail.pymb">
      <div class="item-title">
        <label>培养目标</label>
      </div>
      <div class="item-text">{{majorDetail.pymb}}</div>
    </div>
    <div class="item-zyjs" v-if="majorDetail.pyyq">
      <div class="item-title">
        <label>培养要求</label>
      </div>
      <div class="item-text">{{majorDetail.pyyq}}</div>
    </div>
    <div class="item-zyjs" v-if="majorDetail.nlyq">
      <div class="item-title">
        <label>毕业生能力要求</label>
      </div>
      <div class="item-text">{{majorDetail.nlyq}}</div>
    </div>
    <div class="item-zyjs" v-if="majorDetail.zgxk">
      <div class="item-title">
        <label>主干学科</label>
      </div>
      <div class="item-text">{{majorDetail.zgxk}}</div>
    </div>
    <div class="item-zyjs" v-if="majorDetail.yx">
      <div class="item-title">
        <label>顶尖院校</label>
      </div>
      <div class="item-text">{{majorDetail.yx}}</div>
    </div>
    <div class="item-zyjs" v-if="majorDetail.ksyx">
      <div class="item-title">
        <label>开设院校</label>
      </div>
      <div class="item-text">{{majorDetail.ksyx}}</div>
    </div>
    <div class="item-zyjs" v-if="majorDetail.zygw">
      <div class="item-title">
        <label>职业岗位</label>
      </div>
      <div class="item-text">{{majorDetail.zygw}}</div>
    </div>
    <div class="item-zyjs" v-if="majorDetail.rmhy">
      <div class="item-title">
        <label>热门行业</label>
      </div>
      <div class="item-text">{{majorDetail.rmhy}}</div>
    </div>
    <div class="item-zyjs" v-if="majorDetail.rmcs">
      <div class="item-title">
        <label>热门城市</label>
      </div>
      <div class="item-text">{{majorDetail.rmcs}}</div>
    </div>
    <div class="item-zyjs" v-if="majorDetail.zjtx">
      <div class="item-title">
        <label>专家提醒</label>
      </div>
      <div class="item-text">{{majorDetail.zjtx}}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ZyjdItem",
  props: {
      majorDetail: {
          type: Object,
          default() {
              return {}
          }
      }
  },
};
</script>
<style lang="stylus" scoped>
.item-zyjs
    margin 20px 0   
    .item-title 
        height 20px
        line-height 20px
        padding-left 10px
        border-left 3px solid #efaf49
        font-size 18px
        font-weight 600
        color #efaf49
    .item-text
        box-sizing border-box
        letter-spacing 1px
        padding 16px 
        font-size 14px
        line-height 25px
        color #606266   
</style>